import React, { useEffect } from 'react';

import { APP_CONFIG } from '../../constants';

type MauticTracker = {
  (...args: unknown[]): void;
  q?: unknown[][];
};

declare global {
  interface Window {
    MauticTrackingObject?: string;
    mt?: MauticTracker;
  }
}

export const MauticTracking: React.FC = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || !APP_CONFIG.mautic.enabled) {
      return;
    }

    let tracker = window.mt;

    if (!tracker) {
      // Collect calls made before mtc.js has loaded. The script replaces this
      // stub on load and flushes whatever it finds in the queue.
      const queue: MauticTracker = (...args) => {
        (queue.q = queue.q || []).push(args);
      };
      tracker = queue;
      window.MauticTrackingObject = 'mt';
      window.mt = queue;

      const script = document.createElement('script');
      script.async = true;
      script.src = `${APP_CONFIG.mautic.baseUrl}/mtc.js`;
      document.head.appendChild(script);
    }

    // Only fires on the initial load, not on client-side route changes.
    tracker('send', 'pageview');
  }, []);

  return null;
};
